import React from 'react'

const NotFoundPage = () => {
  return (
    <div />
  )
}

export default NotFoundPage